export default __webpack_public_path__ + "static/media/Londji-ocean-memory-game-2.e99b3f4f.jpg";